import React, { useState, useEffect } from 'react';
import { Window, WindowActionsBar } from '@progress/kendo-react-dialogs';
import Depot from '../../pages/Depot/Depot';
import { Box } from '@mui/material';
import getSetDataService from '../../../../shared/common-utilities/services/getSetDataService';
import Driver from '../../pages/Driver/Driver';
import VehicleResource from '../../pages/VehicleResource/VehicleResource';
import Trailer from '../../pages/Trailer/Trailer';
import VariousResource from '../../pages/VariousResource/VariousResource';
import SubContractor from '../../pages/SubContractor/SubContractor';
import TransportAddress from '../../pages/TransportAddress/TransportAddress';
import PostalCode from '../../pages/TransportAddress/PostalCode';
import PartialTrip from '../../pages/PartialTrip/PartialTrip';
import { PlanFunctionsForFlag } from '../../../../shared/common-utilities/enums/PlanFunctionsEnum';

let service = getSetDataService();

const WindowComponent = (props) => {
    const { dataComponent: DataComponent } = { ...props };
    const [position, setPosition] = useState({ left: 0, top:  0, width: props?.initialWidth, height: props?.initialHeight });
    const [visible, setVisible] = useState(false);
    const [isSendToParentCalled, setIsSendToParentCalled] = useState(true);

    useEffect(() => {
        if (props?.visible) {
            setVisible(true);
            service.setWindowInitialPosition(props?.initialWidth, props?.initialHeight, setPosition);
        }
    }, [props?.visible])

    const onMoveWindow = (event) => {
        service.onMoveWindow(event, position, setPosition);
    };

    const onResizeWindow = (event) => {
        service.onResizeWindow(event, setPosition);
    }
    
    const childStateHandler = (value) => {
        if (value && isSendToParentCalled) {
            let windowHeight = document.getElementById(value)?.offsetHeight + 130;
            if (windowHeight >= window?.innerHeight) {
                windowHeight = window.innerHeight;
            }
            service.setWindowInitialPosition(props?.initialWidth, windowHeight, setPosition);
            setIsSendToParentCalled(false);
        }
    }
    const sendDataToParent = (data) => {
        if(props?.params.for === PlanFunctionsForFlag.PlanMovementsOnAgenda) {
            const obj = props.params?.obj;
            const input = JSON.parse(obj.operationDetail[0].input);
            input.partialTrip = Object.keys(data)[0]
            obj.operationDetail[0].input = JSON.stringify(input);
            props?.sendDataToParent(obj, props?.params.for)
        }
    }

    return (
        <>
            {(props?.visible && visible) && <Window title={props?.title} className='kendo-popup' onClose={props?.onClose} modal={true} left={position.left} top={position.top} height={position.height} onMove={onMoveWindow} onResize={onResizeWindow} {...props}>
                {(props?.isWindowContent) && <Box
                    sx={{ bgcolor: "background.paper" }}
                    className='ctm-subGrid'
                >
                    {(() => {
                        switch (props.title) {
                            case "Select Transport Address":
                                return <TransportAddress isPopup={true} closeConfirmationModal={props?.closeConfirmationModal} params={props?.params} sendDataToParent={childStateHandler} onClose={props?.onClose} style={{ marginBottom: '20px' }}/>
                            case "Select Postal Code":
                                return <PostalCode isPopup={true} addAddress={props?.addAddress} onClose={props?.onClose} params={props?.params} country={props?.country} sendDataToParent={childStateHandler} style={{ marginBottom: '20px' }}/>
                            case "Select Partial Trip":
                                return <PartialTrip isPopup={true}  onClose={props?.onClose} params={props?.params} sendDataToParent={sendDataToParent} style={{ marginBottom: '20px' }}/>
                            default : 
                                return <Depot isPopup={true} openModalDepot={props?.visible} params={props?.params} onClose={props?.onClose} sendDataToParent={childStateHandler} style={{ marginBottom: '20px' }}/>
                        }
                    })()}
                </Box>}

                {props?.title === 'Select Resource' && <Box
                    sx={{
                        bgcolor: "background.paper",
                    }}
                    className='ctm-subGrid'
                >
                    {(() => {
                        const commonProps = {
                            openAddColumnModal: props?.openAddColumnModal,
                            resourceData: props?.resourceData,
                            addResourceApi: props?.addResourceApi,
                            onClose: props?.onClose,
                            gridFlagVal: props?.gridFlagVal,
                            style: { marginBottom: '20px' }
                        };

                        switch (props?.resourceType) {
                            case "driver":
                                return <Driver isPopup={true} {...commonProps} sendDataToParent={childStateHandler} />;
                            case "vehicleCode":
                                return <VehicleResource isPopup={true} {...commonProps} sendDataToParent={childStateHandler} />;
                            case "trailerCode":
                            case "chassis":
                                return <Trailer isPopup={true} {...commonProps} resourceType={props?.resourceType} sendDataToParent={childStateHandler} />;
                            case "variousResCode":
                                return <VariousResource isPopup={true} {...commonProps} sendDataToParent={childStateHandler} />;
                            default:
                                return <SubContractor isPopup={true} {...commonProps} sendDataToParent={childStateHandler} />;
                        }
                    })()}
                </Box>}

                { !(props?.isWindowContent || props?.title === 'Select Movement' ||
                    props?.title === 'Select Resource') && <DataComponent fromDataParam={props?.formData} params={props?.params} message={props?.message} sendDataToParent={childStateHandler}/>
                }
                { props?.actionButtons && 
                    <WindowActionsBar layout='end'>
                        {props.actionButtons} 
                    </WindowActionsBar>
                }
            </Window>}
        </>
    ); 
};

export default WindowComponent;